<template>
    <div>
        <slot></slot>
        <v-row class="content-header">
            <slot name="header"></slot>
        </v-row>
        
        <v-card v-if="filter" outlined class="mb-2 px-3">
            <slot name="filter"></slot>
        </v-card>

        <div v-if="noCard">
            <slot name="body"></slot>
        </div>

        <slot name="body-nocard"></slot>
    </div>
</template>

<script>
export default {
    props: {
        noCard:{
            type: Boolean,
            default: true
        },
        filter:{
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>
.content-header{
    margin: 0px 1px 10px 1px;
}
</style>